import {State} from "../state";
import {Phase2Api} from "../api";
import {getSNodeID} from "../../../../../components/scheduling/util";
import * as Util from "../util";

/**
 * Overrides v2-scheduler table api functions with those that manipulate the purge tool's state.
 * @param _state
 * @param api
 */
export function overrideTableApi(_state: State, api: Phase2Api): Phase2Api {

    const state = _state.purgeEntitiesFromFlightTool;
    const dispatch = api.getDispatch();

    const apiOverride = {
        ...api,
        data: {
            ...api.data,
            modifiedEntities: {
                ...api.data.modifiedEntities,
                get: () => state.data.entities
            },
            getLegs: () => Util.DepDestList.build(apiOverride.data.modifiedEntities.get())
        },
        selection: {
            ...api.selection,
            entityIds: {
                get: () => state.selection.selectedEntityIds,
                set: (newEntities) => dispatch({ type: 'PURGE_TOOL.SET_SELECTED_ENTITY_IDS', set: newEntities }),
                add: (newEntities) => dispatch({ type: 'PURGE_TOOL.SET_SELECTED_ENTITY_IDS', add: newEntities }),
                remove: (removedEntities) => dispatch({ type: 'PURGE_TOOL.SET_SELECTED_ENTITY_IDS', remove: removedEntities }),
                toggle(entityID){
                    if (!state.selection.selectedEntityIds.includes(entityID))
                        this.add([entityID]);
                    else
                        this.remove([entityID]);
                },
                clear: () => dispatch({ type: 'PURGE_TOOL.SET_SELECTED_ENTITY_IDS', set: [] }),
                all: () => {
                    let entities = _state.data.modifiedEntities.map(e => getSNodeID(api.toScheduleNode(e)));
                    dispatch({ type: 'PURGE_TOOL.SET_SELECTED_ENTITY_IDS', set: entities });
                }
            }
        },
        editor: {
            ...api.editor,
            visibleLegs: {
                get: () => state.editor.visibleLegs,
                show: (departureID, destinationID) => {
                    const payload = {
                        departureID: departureID,
                        destinationID: destinationID
                    }
                    dispatch({ type: 'PURGE_TOOL.SET_VISIBLE_LEGS', mode: 'objects', action: 'add', payload: [payload] });
                },
                isLegVisible: (departureID, destinationID) => (
                    Boolean(
                        state.editor.visibleLegs.find((item) => (
                            item.departureID === departureID && item.destinationID === destinationID)
                        )
                    )
                ),
                showAll: () => {
                    const data = Util.DepDestList.build(_state.data.modifiedEntities);

                    const depDestList = data
                        .map(item => ({
                            departureID: item.departure._id,
                            destinationID: item.destination._id
                        }));

                    dispatch({ type: 'PURGE_TOOL.SET_VISIBLE_LEGS', mode: 'objects', action: 'set', payload: depDestList })
                },
                hideAll: () => {
                    dispatch({ type: 'PURGE_TOOL.SET_VISIBLE_LEGS', mode: 'objects', action: 'set', payload: [] });
                },
                setAsStrings: (keys) => (
                    dispatch({ type: 'PURGE_TOOL.SET_VISIBLE_LEGS', mode: 'strings', action: 'set', splitBy: '::', payload: keys })
                ),
                getAsStrings: () => {
                    return state.editor.visibleLegs
                        .map(item => `${item.departureID}::${item.destinationID}`)
                }
            }
        }
    }

    return apiOverride;
}